import { authService } from '@/api/auth.service';
import type { CreateDeviceAuthCodeDto } from '@carvia/ros-client-types';
import { useMutation } from '@tanstack/vue-query';
import { invalidateAuthData } from '@/queries/auth/use-login';

export const useCreateDeviceAuthCode = () => {
  return useMutation({
    mutationKey: ['device-auth-code'],
    mutationFn: (payload: CreateDeviceAuthCodeDto) => authService.createDeviceAuthCode(payload),
  });
};

export const useExchangeDeviceAuthCode = () => {
  return useMutation({
    mutationKey: ['device-auth-exchange'],
    mutationFn: (code: string) => authService.exchangeDeviceAuthCode(code),
    onSuccess: async () => {
      await invalidateAuthData();
    },
  });
};
